import { createFormHook } from '@tanstack/react-form'
import * as React from 'react'
import { FormContext, FormFieldContext } from './form-context'

const { useAppForm, withForm } = createFormHook({
  fieldContext: FormFieldContext,
  fieldComponents: {
    BalanceSlider: React.lazy(() => import('./balance-slider-form-field')),
    Checkbox: React.lazy(() => import('./checkbox-form-field')),
    Control: React.lazy(() => import('./form-field-control')),
    DateInput: React.lazy(() => import('./date-input-form-field')),
    Description: React.lazy(() => import('./form-field-description')),
    Error: React.lazy(() => import('./form-field-error')),
    FileUpload: React.lazy(() => import('./file-upload-form-field')),
    Label: React.lazy(() => import('./form-field-label')),
    NumberInput: React.lazy(() => import('./number-input-form-field')),
    OTPInput: React.lazy(() => import('./otp-input-form-field')),
    Root: React.lazy(() => import('./form-field-root')),
    Select: React.lazy(() => import('./select-form-field')),
    Slider: React.lazy(() => import('./slider-form-field')),
    Switch: React.lazy(() => import('./switch-form-field')),
    TextArea: React.lazy(() => import('./text-area-form-field')),
    TextInput: React.lazy(() => import('./text-input-form-field')),
    TimeInput: React.lazy(() => import('./time-input-form-field')),
  },
  formContext: FormContext,
  formComponents: {
    SubmitButton: React.lazy(() => import('./form-submit-button')),
  },
})

export { useAppForm as use, withForm as with }
